import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import mea from '../../../services/mea';

import CarouselComponent from '../../carousel/CarouselComponent';
import { LoadingComponent } from '../../loading/LoadingComponent';
import ItemCarrouselComponent from '../../carousel/ItemCarrouselComponent';

import './MeaCarouselComponent.scss';

const carouselOptions = {
    accessibility: false,
    dots: false,
    infinite: true,
    speed: 0,
    autoplay: false,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnFocus: true
};

const MeaCarouselComponent = ({ partners, ebonPartners, ebonPartnersFetching, carrouselMeas }) => {
    const render = (partners || ebonPartners) && carrouselMeas && carrouselMeas.length > 0;

    return (
        render && (
            <section className={`accueil-carousel ${ebonPartnersFetching ? 'loading' : ''}`}>
                {ebonPartnersFetching ? (
                    <LoadingComponent />
                ) : (
                    <CarouselComponent id="home-carousel" options={carouselOptions}>
                        {carrouselMeas
                            .sort((a, b) => a.ordreAffichage - b.ordreAffichage)
                            .map((item, i) => {
                                return item.ebon ? (
                                    <ItemCarrouselComponent
                                        item={item}
                                        key={i}
                                        partner={
                                            ebonPartners.find(p => item.idPartenaire === p.id)
                                                ? ebonPartners.find(p => item.idPartenaire === p.id)
                                                : null
                                        }
                                        isEbon
                                    />
                                ) : (
                                    <ItemCarrouselComponent
                                        item={item}
                                        key={i}
                                        partner={
                                            partners[item.idPartenaire]
                                                ? partners[item.idPartenaire]
                                                : null
                                        }
                                        isOffline={item.offline}
                                    />
                                );
                            })}
                    </CarouselComponent>
                )}
            </section>
        )
    );
};

const mapStateToProps = state => {
    return {
        carrouselMeas: mea.selectors.getMeasListByTypeId(state, mea.constants.CAROUSEL_MEA_TYPE),
        partners: state.partner.partners,
        ebonPartners: state.ebon.ebonPartners,
        ebonPartnersFetching: state.ebon.ebonPartnersFetching
    };
};

export default withRouter(connect(mapStateToProps)(MeaCarouselComponent));



// WEBPACK FOOTER //
// ./src/components/pages/home/MeaCarouselComponent.js